<template>
    <b-modal ref="buildingCalculatedTable" v-model="show" size="xl" title="ОБЪЕКТНИНГ ХАРАЖАТ УСУЛИДА БАХОЛАШ КИЙМАТИНИ ХИСОБ - КИТОБИ" class="real-estate-building-calculations"
        :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid pl-0 pr-0" style="min-height: 500px;" v-if="data">
            <div class="row">
                <div class="col-12 table-responsive">
                    <div class="table-wrapper">
                      <table class="table">
                          <tbody>
                              <!--<tr class="bold-row">-->
                                  <!--<td class="text-center" colspan="2">-->
                                      <!--Объектнинг харажат усулида бахолаш кийматини хисоб - китоби-->
                                  <!--</td>-->
                              <!--</tr>-->
                              <tr>
                                  <td width="70%">Мулкдор:</td>
                                  <td width="30%">
                                      <span v-if="data.realEstate && data.realEstate.owner && data.realEstate.owner.firmName">{{data.realEstate.owner.firmName}}</span>
                                      <span v-else-if="data.realEstate && data.realEstate.owner && data.realEstate.owner.fullName">{{data.realEstate.owner.fullName}}</span>
                                  </td>
                              </tr>
                              <tr>
                                  <td width="70%">Манзил:</td>
                                  <td width="30%">
                                      {{(data.realEstate && data.realEstate.address) ? data.realEstate.address : ''}}
                                  </td>
                              </tr>
                              <tr>
                                  <td width="70%">Обеъкт номи:</td>
                                  <td width="30%">{{(data.building && data.building.name) ? data.building.name : ''}}</td>
                              </tr>
                              <tr class="bold-row text-center">
                                  <td colspan="2">
                                      Бинонинг кискача техник тавсифномаси
                                  </td>
                              </tr>
                              <template v-if="data.fields">
                                  <tr v-for="field in data.fields" :key="field.code">
                                      <td width="70%">{{field.name}}</td>
                                      <td width="30%">
                                          <span v-if="field.selected && field.selected.name">{{field.selected.name}}</span>
                                          <span v-else-if="field.valueAsLabel && field.valueAsLabel">{{field.valueAsLabel}}</span>
                                          <span v-else-if="field.value">{{field.value}}</span>
                                      </td>
                                  </tr>
                              </template>
                              <template v-if="data.building">
                                  <tr v-if="data.building.floors">
                                      <td width="70%">Каватлилиги</td>
                                      <td width="30%">{{data.building.floors ? (data.building.floors + ' кават') : ''}}</td>
                                  </tr>
                                  <tr v-if="data.building.height">
                                      <td width="70%">Бинонинг баландлиги</td>
                                      <td width="30%" class="text-right">{{data.building.height ? (data.building.height + ' м') : ''}}</td>
                                  </tr>
                                  <tr v-if="data.building.area">
                                      <td width="70%">Курилиш ости майдони</td>
                                      <td width="30%" class="text-right">{{data.building.area ? (data.building.area + ' м2') : ''}}</td>
                                  </tr>
                                  <tr v-if="data.building.volume">
                                      <td width="70%">Бинонинг хажми</td>
                                      <td width="30%" class="text-right">{{data.building.volume ? (data.building.volume + ' м3') : ''}}</td>
                                  </tr>
                                  <tr>
                                      <td width="70%">
                                          Бинонинг {{data.building.cadastreBuilding.recoveryValueTxt}} тикланиш киймати УКУП буйича
                                          {{(data.building.cadastreBuilding && data.building.cadastreBuilding.tableInfo && data.building.cadastreBuilding.tableInfo.length > 0) ?
                                          ('(' + data.building.cadastreBuilding.tableInfo + ')') : ''}}
                                      </td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.recovery.pricePerUnit | currency('', 2, { thousandsSeparator: ' ' })}} сўм</strong></td>
                                  </tr>
                                  <tr>
                                      <td width="70%">Айрим конструктив элементларига узгартириш киритган холда</td>
                                      <td width="30%" class="text-right">{{data.building.calculated.constructive.change | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                  </tr>
                                  <tr>
                                      <td width="70%">1991 йил бахоларида бинонинг тиклаш киймати</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.recovery.price1991 | currency('', 2, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>

                                  <template v-if="data.coefficient && data.coefficient.index && data.coefficient.index.length > 0">
                                      <tr v-for="(index, i) in data.coefficient.index" :key="index.code">
                                          <td width="70%" v-if="i===0">{{index.code}} холатига курилиш материаларини кимматлаш индекси</td>
                                          <td width="70%" v-else>{{index.code}} холатига Госкомстат индекси</td>
                                          <td width="30%" class="text-right"><strong>{{index.value | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                      </tr>
                                  </template>

                                  <tr>
                                      <td width="70%">{{data.building.earthquakePoint}} баллик зилзилага бардошлик зонаси коэффициенти</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.coefficient.earthquake | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>
                                  <tr>
                                      <td width="70%">{{data.realEstate.province.name}} учун тугрилаш коэффициенти</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.coefficient.regional | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>
                                  <tr>
                                      <td width="70%">Капиталликнинг узгариши коэффиценти</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.coefficient.capital | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>
                                  <tr>
                                      <td width="70%">Баландлигига таъсир этувчи коэффиценти</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.coefficient.height | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>
                                  <tr>
                                      <td width="70%">Хажмига таъсир этувчи коэффиценти</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.coefficient.volume | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>
                                  <tr>
                                      <td width="70%">Тадбиркор фойдаси коэффиценти</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.coefficient.business | currency('', 3, { thousandsSeparator: ' ' })}}</strong></td>
                                  </tr>

                                  <tr>
                                      <td width="70%">Бахоланаётган кунга бинонинг бахоси</td>
                                      <td width="30%" class="text-right"><strong>{{data.building.calculated.price.building | currency('', 2, { thousandsSeparator: ' ' })}} сўм</strong></td>
                                  </tr>

                                  <tr class="bold-row text-center">
                                      <td colspan="2">Жисмоний эскириш хисоб - китоби</td>
                                  </tr>
                                  <tr>
                                      <td colspan="2">
                                          <div class="table-responsive">
                                              <table class="customers">
                                                  <thead>
                                                  <tr>
                                                      <th width="30%">Конструктив элемент номи</th>
                                                      <th width="10%">Хисоб огирлиги</th>
                                                      <th width="15%">Хисоб огирлигига узгартириш</th>
                                                      <th width="15%">Кейинги хисоб огирлик</th>
                                                      <th width="15%">Емирилиш (%)</th>
                                                      <th width="15%" style="width: 100%;padding: 12px 8px">Хисобий емирилиш</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  <tr v-for="field in data.depreciationFields" :key="field.code">
                                                      <td>{{field.name}}</td>
                                                      <td class="text-right">{{field.weight | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right">{{field.change | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right">{{field.next | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right">{{field.erosion | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right">{{field.calculated | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                  </tr>
                                                  <tr class="bold-row">
                                                      <td>Жами:</td>
                                                      <td class="text-right">{{data.building.calculated.depreciation.weight | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right">{{data.building.calculated.depreciation.change | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right">{{data.building.calculated.depreciation.next | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td class="text-right"></td>
                                                      <td class="text-right">{{data.building.calculated.depreciation.calculated | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                  </tr>
                                                  <tr>
                                                      <td colspan="4">
                                                          Бинонинг жисмоний эскириши
                                                      </td>
                                                      <td colspan="2" class="text-right">{{data.building.calculated.depreciation.percent | currency('', 2, { thousandsSeparator: ' ' })}} %</td>
                                                  </tr>
                                                  <tr>
                                                      <td colspan="4">
                                                          Эскириш сўммаси
                                                      </td>
                                                      <td colspan="2" class="text-right">{{data.building.calculated.depreciation.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм</td>
                                                  </tr>
                                                  <tr class="bold-row">
                                                      <td colspan="4">
                                                          Бинонинг харажат усулида бахоланиш киймати
                                                      </td>
                                                      <td colspan="2" class="text-right">{{data.building.calculated.price.expense | currency('', 2, { thousandsSeparator: ' ' })}} сўм</td>
                                                  </tr>
                                                  </tbody>
                                              </table>
                                          </div>
                                      </td>
                                  </tr>
                              </template>
                          </tbody>
                      </table>
                    </div>
                </div>
            </div>
        </div>

        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn float-right mr-2" @click="close">
                OK
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    export default {
        name: "RealEstateBuildingCalculatedView",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                data: {}
            }
        },
        methods: {
            close() {
                this.$refs.buildingCalculatedTable.hide();
            }
        },
        created() {
            this.$eventBus.$on('showRealEstateBuildingCalculatedTable', (data) => {
                this.data = data;
                console.log(this.data)
                this.show = true;
            });
        }
    }
</script>

<style>
    .real-estate-building-calculations .modal-dialog {
        max-width: 1100px;
        width: 1100px !important;
    }
    .real-estate-building-calculations .modal-content {
        width: 1100px !important;
    }
</style>
